import { Component, Prop, h, State } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { desktopBannerMessage, mobileBannerMessage } from '../../constants/constants';
import { setFeatureFlagsFromUrl, signaler } from '../../utils/signaler';

@Component({
  tag: 'ci-header',
  styleUrl: 'ci-header.scss',
})
export class CustominkHeader {
  @Prop() headerFlavor: 'default' | 'simple' = 'default';
  @Prop() serviceNumber: string; // Allow an optional serviceNumber prop
  @State() dynamicServiceNumber: string = '';
  @Prop() mobileBannerMessage: string = mobileBannerMessage;
  @Prop() desktopBannerMessage: string = desktopBannerMessage;
  @Prop() signaler = signaler;

  async componentWillLoad() {
    setFeatureFlagsFromUrl(this.signaler);
    window.dispatchEvent(new Event('ciHeaderLoaded'));

    // If serviceNumber prop is not provided, fetch the dynamic service number
    if (!this.serviceNumber) {
      const fetchedServiceNumber = await getServiceNumber();  // Wait for the service number to resolve
      this.dynamicServiceNumber = fetchedServiceNumber;
    } else {
      this.dynamicServiceNumber = this.serviceNumber;
    }
  }

  render() {
    const serviceNumber = this.serviceNumber || this.dynamicServiceNumber;

    if (this.headerFlavor == 'simple') {
      return <simple-header serviceNumber={serviceNumber} />;
    } else {
      return (
        <default-header
          serviceNumber={serviceNumber}
          mobileBannerMessage={this.mobileBannerMessage}
          desktopBannerMessage={this.desktopBannerMessage}
        />
      );
    }
  }
}
